// import { ui_setting } from '../../../static/assets/js/ui_setting.js'

import captcha from '@/components/bid/captcha/captcha.vue';
import bidApi from '@/api/bid/bidApi';
import { ui_setting } from '@/util/ui_setting.js'

const MOBILEREG =  /^[09]{2}[0-9]{8}$/;
const IDNUMBERREG =  /^[a-zA-Z0-9]+$/;
const BIDTYPE = {
	happyPackage: ['bidCode', 'returnUrl'],
	happyPackageGroup: ['returnUrl']

};
export default {
	name: 'bid-login',
	mixins: [],
	extends: {},
	components: {captcha},
	props: [],
	data() {
		return {
			idNumber: null,
			mdn: null,
			bidType: null,
			bidCode: null,
			returnUrl: null,
			returnLoginUrl: null,
			temp: {},
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {
		//ui_setting();
		$('.popup-iframe').magnificPopup({
			//type: 'iframe',
			//type: 'inline',
			closeOnBgClick: false,
			closeBtnInside: false,
			enableEscapeKey: false,
			showCloseBtn: false,
			preloader: true,
			midClick: true,
			removalDelay: 100,
			mainClass: 'my-mfp-slide-bottom',
			overflowY: 'hidden',
			fixedContentPos: true,
			//closeMarkup: '<button title="%title%" type="button" class="mfp-close"><img src="static/assets/img/closeX.png" class="mfp-close"></button>'
	
		});
		
		$('.iframeS').on('click', function (e) {
			$(".mfp-content").css('max-width', '500px');
			var frameh = 430;
			//  $(".mfp-content,.mfp-content .mfp-iframe-scaler,.mfp-content iframe").css('height', frameh + 'px');
		});
		
		$('#showLogin').click();
		this.pageInit();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async pageInit() {
			this.clearQuickLogin();
			this.bidQueryValidation();
			//this.verifyIsLogin();
		},
		async login() {
			
			// 前端驗證成功
			if( this.bidLoginValidation() ) {
				// 後端驗證資料 
				const model = { 
					mdn: this.mdn,
					idNumber: this.idNumber
				}

				// 後端驗證
				var authResp = await bidApi.verifyAuth(model);

				// 後端驗證成功
				if (authResp && authResp.result) {

					// 存入 token 
					sessionStorage.setItem('bidMdn', this.mdn);
					sessionStorage.setItem('bidToken', authResp.token);
					sessionStorage.setItem('bidReturnLoginUrl', this.returnLoginUrl);
					this.processByBidType();
					
				}
				else {
					this.$router.push({ name: "bid-warn", params: { msg: authResp && authResp.errMsg, returnUrl: this.returnLoginUrl } });
				}
			}
			$.magnificPopup.close();
		},
		bidLoginValidation() {
			let msgCode = null;
			if (!this.idNumber  || !this.mdn) {
				msgCode = "門號或證號不可為空";
			}
			else if (!this.mdn.match(MOBILEREG)) {
				msgCode = "您輸入的門號格式錯誤，請重新輸入";
			}
			else if (!this.idNumber.match(IDNUMBERREG)) {
				msgCode = "您輸入的身份證號碼／統編只能輸入英數字，請重新輸入";
			}
			else if (!(this.$refs.captcha.verfiyCaptcha())) {
				msgCode = "驗證碼錯誤";
			}
			if(msgCode != null){
				this.$router.push({ name: "bid-warn", params: { msg: msgCode, returnUrl: this.returnLoginUrl } });
				$.magnificPopup.close();
				return false;
			}
			return true;
		},
		bidQueryValidation() {
			this.bidType = this.$route.query.bidType;
			this.bidCode = this.$route.query.bidCode;
			this.returnUrl = this.$route.query.returnUrl;
			this.returnLoginUrl = "/Service/#/bid/login" + "?bidType="   + this.bidType 
											    + "&bidCode="   + this.bidCode
												+ "&returnUrl=" + encodeURIComponent(this.returnUrl);
			// 缺少其中一個參數，或者bidType類型是不可處理的類型
			if (!this.bidType || !BIDTYPE[this.bidType] ) {
				this.$router.push({ name: "bid-warn", params: { msg: "參數錯誤", returnUrl: process.env.MAIN_PAGE } });
				$.magnificPopup.close();
			}
			BIDTYPE[this.bidType].forEach(bt => {
				if (!this[bt]) {
					this.$router.push({ name: "bid-warn", params: { msg: "參數錯誤", returnUrl: process.env.MAIN_PAGE } });
					$.magnificPopup.close();
				}
			});
		},
		/*
		async verifyIsLogin() {
			if(sessionStorage.getItem('bidMdn') && sessionStorage.getItem('bidToken')) {
				const verifyTokenResp = await bidApi.verifyToken(sessionStorage.getItem('bidMdn'), sessionStorage.getItem('bidToken'));
				if (verifyTokenResp && verifyTokenResp != '401') {
					this.mdn = sessionStorage.getItem('bidMdn');
					this.processByBidType();
					$.magnificPopup.close();
				}
			}
		},
		*/
		processByBidType() {
			if ('happyPackageGroup' == this.bidType) {
				window.location.href = decodeURIComponent(this.returnUrl);
			} else {
				// normal
				this.processShopping();
			}
		},
		async processShopping() {
			// 取得要購買的快樂包的資訊
			var bidHappyPackageResp = await bidApi.getBidHappyPackage(this.mdn, this.bidCode);

			if (bidHappyPackageResp ) {
				if(bidHappyPackageResp.exist) {
					if (bidHappyPackageResp.applyStatus == 'A') {
						this.$router.push({ name: "bid-warn", params: { msg: "您已購買過此快樂包", returnUrl: this.returnUrl } });
					}
					else if (bidHappyPackageResp.applyStatus == 'D') {
						if (bidHappyPackageResp.enable) {
							const changeSetServiceStatusResp = await bidApi.changeSetServiceStatus(this.mdn, this.bidCode, 'A');
							if (changeSetServiceStatusResp && changeSetServiceStatusResp.result == "0") {
								this.$router.push({name: 'bid-success', params: { title : bidHappyPackageResp.title, returnUrl: this.returnUrl }});
							}
							else { 
								this.$router.push({ name: "bid-warn", params: { msg: changeSetServiceStatusResp && changeSetServiceStatusResp.errMsg, returnUrl: this.returnUrl } });
							}
						}
						else {
							this.$router.push({ name: "bid-warn", params: { msg: "此快樂包已下架", returnUrl: this.returnUrl } });
						}
					}
				}
				else {
					this.$router.push({ name: "bid-warn", params: { msg: "此快樂包不存在", returnUrl: this.returnUrl } });
				}
			}
		},
		clearQuickLogin() {
			this.temp.bidMdn = sessionStorage.getItem("bidMdn");
			this.temp.bidToken = sessionStorage.getItem("bidToken");
			this.temp.bidReturnLoginUrl = sessionStorage.getItem("bidReturnLoginUrl");
			sessionStorage.removeItem("bidMdn");
			sessionStorage.removeItem("bidToken");
			sessionStorage.removeItem("bidReturnLoginUrl");
		},
		goToPrePage() {
			if ('happyPackageGroup' == this.bidType) {
				if (sessionStorage.getItem('bidHistoryPage')) {
					if (sessionStorage.getItem('bidHistoryPage').match(/^.*\/[Hh]{1}appyPackage\/.*$/)) {
						sessionStorage.setItem('bidMdn', this.temp.bidMdn);
						sessionStorage.setItem('bidToken', this.temp.bidToken);
						sessionStorage.setItem('bidReturnLoginUrl', this.temp.bidReturnLoginUrl);
					}
					window.location.href = sessionStorage.getItem('bidHistoryPage');
				} else {
					window.location.href = sessionStorage.getItem('historyPage');
				}
			} else {
				// normal
				window.history.go(-1);
			}
		}
	},
}



// WEBPACK FOOTER //
// ./src/components/bid/bidLogin.js